/**
 * Ryan O'Dowd
 * 2018-10-13
 * © Copyright 2018 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors, isDarkMode, safeAreaInsets}) => {
  return {
    innerContainerWrapper: {
      paddingBottom: safeAreaInsets.bottom + 4,
    },
    innerContainer: {
      flex: 1,
      padding: 16,
    },
    headerText: {
      fontFamily: fonts.primaryBold,
      fontSize: globalScale * 18,
      color: colors.white,
    },
    text: {
      flex: 1,
      fontSize: globalScale * 15,
      marginBottom: globalScale * 16,
      color: colors.white,
    },
    accentTitle: {
      color: colors.accent,
      fontFamily: fonts.primaryBold,
      paddingLeft: 32,
    },
    lineOne: {
      marginBottom: 0,
    },
    actions: {
      justifyContent: 'center',
      flexDirection: 'row',
      paddingBottom: 16,
    },
    shareButtonsWrapper: {
      display: 'flex',
      flexDirection: 'row',
      height: 100,
    },
    shareOption: {
      width: globalScale * 68,
      display: 'flex',
      flexDirection: 'row',
    },
    buttonAndTextWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: globalScale * 68,
    },
    buttonImageWrapper: {
      display: 'flex',
      margin: globalScale * 8,
      marginBottom: globalScale * 2,
      justifyContent: 'center',
      alignItems: 'center',
    },
    buttonImage: {
      display: 'flex',
      width: globalScale * 48,
      height: globalScale * 48,
      borderRadius: globalScale * 8,
      overflow: 'hidden',
      cursor: 'pointer',
    },
    buttonIcon: {
      display: 'flex',
      padding: globalScale * 8,
      fontSize: globalScale * 30,
      color: isDarkMode ? colors.white : colors.black,
      borderWidth: 0.5,
      backgroundColor: colors.primaryExtraLight,
      textAlign: 'center',
      alignItems: 'center',
    },
    buttonNameText: {
      display: 'flex',
      fontSize: globalScale * 12,
      textAlign: 'center',
      color: colors.white,
    },
    verticalDivider: {
      backgroundColor: colors.lightGray,
      width: 2,
      height: 64,
      alignSelf: 'center',
    },
    horizontalDivider: {
      backgroundColor: colors.lightGray,
      width: '100%',
      height: 2,
      margin: 8,
      alignSelf: 'center',
    },
    otherInfoWrapper: {
      marginBottom: 4,
    },
    statText: {
      color: colors.accent,
      fontFamily: fonts.primaryBold,
    },
  };
};

export default getStyles;
